import Styles from './PropertyListItem.module.scss'
import {
  DocumentPropertyValue,
  PersonPropertyValue,
  Property,
  PropertyValue as PropertyValueType,
  AssigneeType,
} from 'api/clients/PropertyClient'
import { PropertyItem } from '../PropertyItem/PropertyItem'
import { Response } from 'request-dot-js'
import cx from 'classnames'
import { useState, useEffect } from 'react'
import { highlightPropertiesByName } from '../../redux/actions/properties'
import { useDispatch } from 'react-redux'
import { PropertyValue } from './PropertyValue'
import { OptionSelectVariant } from 'common/OptionSelect/OptionSelect'

interface Props {
  assignee?: {
    id: string
    type: AssigneeType
  }
  property: Property
  isHighlighted?: boolean
  availableProperties?: Property[]
  selectedPropertyValues: PropertyValueType[]
  disabled: boolean
  propertyActionsOpen?: boolean
  propertyValuesOpen?: boolean
  onSearch?: (query: string) => void
  openPropertyActions?: (propertyId: number | undefined) => void
  onCreateProperty?: (property: Property) => void
  onUpdateProperty?: (property: Property, isUndoAction?: boolean) => Promise<Response<{ property: Property }>>
  onRemoveProperty?: () => void
  onSelectValue?: (propertyValues: PropertyValueType[] | DocumentPropertyValue[] | PersonPropertyValue[]) => void
  onCreateValue?: (propertyValue: PropertyValueType) => void
  onUpdateValue?: (propertyValue: PropertyValueType) => void
  onDeleteValue?: (propertyValue: PropertyValueType) => void
  variant?: OptionSelectVariant
}

export const DocInfoPropertyListItem = ({ assignee, property, selectedPropertyValues, disabled }: Props) => {
  return (
    <>
      <div className={cx(Styles.items, { [Styles.disabled]: disabled })}>
        <PropertyItem property={property} icon={() => <></>} />
        <PropertyValue
          disabled={disabled}
          assignee={assignee}
          property={property}
          selectedPropertyValues={selectedPropertyValues}
          isEditing={false}
        />
      </div>
    </>
  )
}

export const FolderPropertyListItem = ({
  assignee,
  property,
  isHighlighted,
  availableProperties,
  selectedPropertyValues,
  onSearch,
  disabled,
  openPropertyActions,
  propertyActionsOpen,
  propertyValuesOpen,
  onRemoveProperty,
  onCreateProperty,
  onUpdateProperty,
  onSelectValue,
  onCreateValue,
  onUpdateValue,
  onDeleteValue,
  variant,
}: Props) => {
  const dispatch = useDispatch()
  useEffect(() => {
    if (!isHighlighted) return

    setTimeout(() => {
      dispatch(highlightPropertiesByName({ Status: false }))
    }, 1600) // remove highlight after animation finishes
  }, [isHighlighted, dispatch])

  const [isEditing, setIsEditing] = useState(false)

  return (
    <>
      <div className={cx(Styles.items, { [Styles.highlighted]: isHighlighted, [Styles.disabled]: disabled })}>
        <PropertyItem
          property={property}
          availableProperties={availableProperties}
          onSearch={onSearch}
          actionsOpen={propertyActionsOpen}
          onCreate={onCreateProperty}
          onUpdate={onUpdateProperty}
          openPropertyActions={openPropertyActions}
          onRemove={onRemoveProperty}
        />
        <PropertyValue
          disabled={disabled}
          assignee={assignee}
          edit={propertyValuesOpen}
          property={property}
          selectedPropertyValues={selectedPropertyValues}
          onSelect={onSelectValue}
          onCreate={onCreateValue}
          onUpdate={onUpdateValue}
          onDelete={onDeleteValue}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          variant={variant}
        />
      </div>
    </>
  )
}
